<main fxLayout='column' fxLayoutAlign="flex-start center">

  <main *ngIf="displayValue.length == 0 && loading == false" fxLayout="column" fxLayoutAlign="center center">
    <h1>{{'noData' | translation}}</h1>
  </main>
  <div *ngIf="loading">
    <h1>{{'loadingData' | translation}}</h1>
    <div id="matspinner">
      <mat-spinner style="margin:0 auto;" color="accent" mode="indeterminate"></mat-spinner>
    </div>
  </div>


  <ng-container *ngIf="this.dataValue.length > 0 && displayDataSources">
     <ng-container *ngIf="firebaseService.user.uid == 'GAuxr5C3VfOjXbccGvGirOAGqf52' && displayDataSources.length != 0">


    <app-data-display  [displayDataSources]="displayDataSources"></app-data-display>
    <div>

      <p>Selection de date</p>
      <mat-form-field>

        <input matInput [matDatepicker]="datePicker" [(ngModel)]="parseDate" (ngModelChange)="changeSourceDate()" disabled>
        <mat-datepicker-toggle name="datePicker" ngDefaultControl matSuffix [for]="datePicker"></mat-datepicker-toggle>
        <mat-datepicker #datePicker disabled="false"></mat-datepicker>
        <button *ngIf="parseDate" matSuffix mat-icon-button aria-label="Clear" (click)="changeSourceDate('clear')">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
    </ng-container>


     <ng-container>
       <p>{{displayValue.length}}</p>
       <div class="tableContainer" *ngFor="let item of displayValue; let i = index" fxLayout='column'
            fxLayoutAlign="center center">

         <header fxLayout="column" fxLayoutAlign="center center">
           <!-- <div>
    <h1>Module</h1>
    <p>{{dataValue[i].module}}</p>
  </div>   -->

           <p>{{'module' | translation}}</p>
           <h1 *ngIf="dataValue[i]">{{dataValue[i].module}}</h1>
           <div *ngIf="dataValue[i] && this.dataValue[i].module == 'quiz'">
             <p>{{'quizName' | translation}}</p>

             <h1>{{dataValue[i].title}}</h1>
           </div>
           <div *ngIf="dataValue[i] && this.dataValue[i].module == 'lottery' && this.dataValue[i].title != null">
             <p>{{'lotteryName' | translation}}</p>

             <h1>{{dataValue[i].title}}</h1>
           </div>

         </header>


     <!--    -->

         <app-table *ngIf="displayDataSources" [data]="displayDataSources[i]" [column]="displayedColumns[i]"></app-table>
       <!--  <div class="mat-table-wrapper mat-elevation-z8">
           <table matSort matTableExporter mat-table [dataSource]="displayDataSources[i]" #exporter="matTableExporter"
                  #dataTable>

             <ng-container *ngFor="let columns of displayedColumns[i]" [matColumnDef]="columns">
               <th mat-header-cell *matHeaderCellDef mat-sort-header> {{columns}} </th>
               <td mat-cell *matCellDef="let element">
                 <ng-container *ngIf="checkIfUrl(element, columns)">
                   <img class="thumbnail" [src]="element[columns]" (click)="openImage(element, columns)" />
                 </ng-container>
                   <ng-container *ngIf="!checkIfUrl(element, columns)">
                     {{element[columns]}}
                   </ng-container>
                 </td>
               </ng-container>

               <tr mat-header-row *matHeaderRowDef="displayedColumns[i]"></tr>
               <tr mat-row *matRowDef="let row; columns: displayedColumns[i];"></tr>
             </table>

             <mat-paginator [pageSizeOptions]="[25, 100]"></mat-paginator>
           </div>-->

           <footer>
             <button id="btnAddQuestion" mat-raised-button color="accent" (click)="export(item, this.dataValue[i].module)">
               <mat-icon>save_alt</mat-icon>{{'exportData' | translation}}
             </button>
             <button id="btnAddQuestion" mat-raised-button color="warn" (click)="deleteData(this.dataValue[i].module, dataValue[i].quizId, dataValue[i].title)">
               <mat-icon>delete</mat-icon>{{'deleteData' | translation}}
             </button>
           </footer>

         </div>
       </ng-container>
    </ng-container>


  </main>
